export const PERMITS_LAYER_TYPE_ID = "US_PERMITS_LAYER_TYPE";
